__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@msdk/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@msdk/common", "1.102.1", () => (() => (__webpack_require__(3122))), 1);
			register("@msdk/definitions", "1.145.0", () => (() => (__webpack_require__(2781))), 1);
			register("@msdk/forms", "1.176.2", () => (() => (__webpack_require__(4482))), 1);
			register("@msdk/telemetry", "1.48.1", () => (() => (__webpack_require__(8679))), 1);
			register("@msdk/ui", "1.165.2", () => (() => (__webpack_require__(7723))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(3565))), 1);
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(4397))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(2132))), 1);
			register("recoil", "0.7.7", () => (() => (__webpack_require__(9333))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};